import { apiGet } from "../qv4/models/shared/apiClient";

export function serializeAssignmentHistoryFilters({ page = 1, pageSize = 50, source, status, toAgentName, actorName, range, search }) {
  const params = new URLSearchParams({ page: String(page), page_size: String(pageSize) });
  if (source) params.set("assignment_source", source);
  if (status) params.set("status", status);
  if (toAgentName) params.set("to_agent_name", toAgentName);
  if (actorName) params.set("assigned_by_name", actorName);
  if (range?.[0]) params.set("from", range[0].toISOString());
  if (range?.[1]) params.set("to", range[1].toISOString());
  if (search?.trim()) params.set("search", search.trim());
  return params.toString();
}

export async function fetchAssignmentHistory(filters) {
  const response = await apiGet(`/round_robin/assignment-history?${serializeAssignmentHistoryFilters(filters)}`);
  if (!response.data?.success) throw new Error(response.data?.message || "Chat assignment history could not be loaded.");
  return response.data.data;
}

export function assignmentActorLabel(row) {
  return row.assignment_actor_type === "system"
    ? "Automatic round robin"
    : row.assigned_by_name || "Unknown staff member";
}

export const assignmentIdentityLabel = (name, watiId) => name?.trim() || (watiId ? `WATI agent ${watiId}` : "Not assigned");
